import { useEffect, useMemo, useState } from "react";
import { clientCallAPI } from "~/services/clientCallAPI";

type Option = { label: string; value: string };
type Ward = { id: string; name: string };

const cache = new Map<string, Option[]>();

export function useWards(provinceId?: string) {
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!provinceId) {
      setOptions([]);
      return;
    }
    const cached = cache.get(provinceId);
    if (cached) {
      setOptions(cached);
      return;
    }
    setLoading(true);
    clientCallAPI<{ data: Ward[] }>(`/api/address/province/${provinceId}/ward?pageSize=999`)
      .then((res: any) => {
        const list: Option[] = (res?.data || res || []).map((w: any) => ({
          label: w.name,
          value: w.id,
        }));
        cache.set(provinceId, list);
        setOptions(list);
      })
      .catch(() => setOptions([]))
      .finally(() => setLoading(false));
  }, [provinceId]);

  return { options, loading };
}
